import React, { createContext, useContext, useEffect ,useState} from "react";
import { useLocalStorage } from "../utils/hooks";
import { platformApi } from "../api";

const BranchContext = createContext({
  selectBranch: [],
  setSelectBranch: () => {},
  nearestBranch: null,
  branches: [],
  setBranches: () => {},
});

export const useBranch = () => {
    return useContext(BranchContext);
};
// const branches = [
//   { id: 1, name: "Devanhalli", lat: 13.261225783406609, lon: 77.71901755014581 },
//   { id: 2, name: "Doddaballapur", lat: 13.2853252 , lon: 77.5456050 },
// ];

export function getDistance(lat1, lon1, lat2, lon2) {
  const R = 6371;
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLon = ((lon2 - lon1) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos((lat1 * Math.PI) / 180) *
      Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLon / 2) ** 2;
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
}

const BranchProvider = (props) => {
    const [selectBranch, setSelectBranch] = useLocalStorage("branch");
    const [nearestBranch, setNearestBranch] = React.useState(null);
  //   const [branches, setBranches] = React.useState(() => {
  //   const saved = localStorage.getItem("branches");
  //   return saved ? JSON.parse(saved).map(b => ({
  //     ...b,
  //     lat: b.lat ? Number(b.lat) : null,
  //     lon: b.lon ? Number(b.lon) : null,
  //   })) : [];
  // });
  // useEffect(() => {
  //   if (branches.length > 0) {
  //     localStorage.setItem("branches", JSON.stringify(branches));
  //   }
  // }, [branches]);
  const [branches, setBranches] = useState([]);

  // 🔹 Fetch branches from backend instead of localStorage
  useEffect(() => {
    const fetchBranches = async () => {
      try {
        const res = await platformApi.post("/api/company/branches/get", {
          page: 1,
          size: 100, // adjust as needed
          searchString: "",
        });
        if (res.data?.response?.data?.branch) {
          const branchList = res.data.response.data.branch.map((b) => ({
            ...b,
            lat: b.lat ? Number(b.lat) : null,
            lon: b.lon ? Number(b.lon) : null,
          }));
          setBranches(branchList);
        }
      } catch (err) {
        console.error("Error fetching branches:", err);
      }
    };

    fetchBranches();
  }, []);
     
    useEffect(() => {
      if (branches.length === 0) return;
    // Auto-select nearest branch for Quotations & Job Card
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          console.log("✅ Geolocation SUCCESS:", position.coords);
          const userLat = position.coords.latitude;
          const userLon = position.coords.longitude;
          console.log("User Current Location: ", { lat: userLat, lon: userLon });
          let nearest = branches[0];
          let minDistance = Infinity;
          branches.forEach((branch) => {
            if (branch.lat && branch.lon) {
              const distance = getDistance(userLat, userLon, branch.lat, branch.lon);
              if (distance < minDistance) {
                minDistance = distance;
                nearest = branch;
              }
            }
          });
          setNearestBranch(nearest); // store nearest branch locally
        },
        (error) => {
          console.error("❌ Geolocation ERROR:", {
            code: error.code,
            message: error.message,
            codeNames: {
              1: "PERMISSION_DENIED",
              2: "POSITION_UNAVAILABLE",
              3: "TIMEOUT"
            }
          });
          setNearestBranch(branches[0]); // fallback
        },
        {
          enableHighAccuracy: false,
          timeout: 10000,
          maximumAge: 300000
        }
      );
    } else {
      console.warn("⚠️ Geolocation not supported in this browser");
      setNearestBranch(branches[0]); // fallback
    }
  }, [branches]);

    const variables = {
      selectBranch,
      setSelectBranch,
      nearestBranch,
      branches,
      setBranches,
    };

    return <BranchContext.Provider value={variables}>{props.children}</BranchContext.Provider>;
};

export default BranchProvider;